export const findDuplicatesInArray = (arr: any[]): any[] => {
  const uniq = arr
    .map((value: any) => {
      return {
        count: 1,
        value,
      };
    })
    .reduce((a: any, b: any) => {
      a[b.value] = Number(a[b.value] || 0) + Number(b.count);
      return a;
    }, {});

  return Object.keys(uniq).filter((a) => uniq[a] > 1);
};
